/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q10Inputs */

const en_pc_faq_q10 = /** @type {(inputs: Pc_Faq_Q10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a PdfCraft app for iPhone or Android?`)
};

const zh_pc_faq_q10 = /** @type {(inputs: Pc_Faq_Q10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 有 iPhone 或安卓应用吗？`)
};

/**
* | output |
* | --- |
* | "Is there a PdfCraft app for iPhone or Android?" |
*
* @param {Pc_Faq_Q10Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q10 = /** @type {((inputs?: Pc_Faq_Q10Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q10Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q10(inputs)
	return zh_pc_faq_q10(inputs)
});
export { pc_faq_q10 as "pc.faq.q10" }